import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { compose } from 'redux';

import BasicFormField from '../../../../../common/formFields/basicFormField';
import withToggle from '../../../../../common/hoc/withToggle';

const ShopifyUrlField = ({ placeholderIsOn, placeholderOff }) => (
  <div className="shopify-url-field">
    {/* Background field hides after placeholder clicked */}
    <BasicFormField
      display-if={placeholderIsOn}
      label="SHOPIFY URL"
      name="shopifyUrl"
      onFocus={() => placeholderOff()}
      wrapperClass="connect-to-shopify__field"
    />
    {/* Autofocus field appears after placeholder clicked */}
    <BasicFormField
      autoFocus
      display-if={!placeholderIsOn}
      placeholder="yourshop.myshopify.com"
      label="SHOPIFY URL"
      name="shopifyUrl"
      wrapperClass="connect-to-shopify__field"
    />
    {/* Hide-on-click 2 colors placeholder */}
    <div
      className={classNames('shopify-url-field__placeholder', {
        'shopify-url-field__placeholder__show': placeholderIsOn,
      })}
      onClick={() => placeholderOff()}
    >
      yourshop.<strong>myshopify.com</strong>
    </div>
  </div>
);

ShopifyUrlField.propTypes = {
  placeholderIsOn: PropTypes.bool.isRequired,
  placeholderOff: PropTypes.func.isRequired,
};

export default compose(
  withToggle('placeholder', true),
)(ShopifyUrlField);
